export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.
    SausageIntegration: 'specs.events.ui.SausageIntegration', // false 100%, 2024-11-08
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    AiEventsAssistantV2: 'specs.events.ui.AiEventsAssistantV2',
    AiEventsQaAssistant: 'specs.events.ui.AiEventsQaAssistant',
    AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
    AiTicketsQaAssistant: 'specs.events.ui.AiTicketsQaAssistant',
    AiEventsListQaAssistant: 'specs.events.ui.AiEventsListQaAssistant',
    AiChangeEventTypeAssistant: 'specs.events.ui.AiChangeEventTypeAssistant',
    AiOnlineEventQaAssistant: 'specs.events.ui.AiOnlineEventQaAssistant',
    AiDetailsPageStyleQaAssistant: 'specs.events.ui.AiDetailsPageStyleQaAssistant',
    AiCheckInAppQaAssistant: 'specs.events.ui.AiCheckInAppQaAssistant',
    AiAddStaffMemberAssistant: 'specs.events.ui.AiAddStaffMemberAssistant',
    ServerlessWidgetData: 'specs.events.ui.ServerlessWidgetData',
    CurvedMultiRowAnnouncement: 'specs.seatings.ui.CurvedMultiRowAnnouncement',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    AutomationsBanner: 'specs.events.ui.AutomationsBanner',
    AiCopyTicketsAssistant: 'specs.events.ui.AiCopyTicketsAssistant',
    SkillTicketPolicy: 'specs.events.ui.SkillTicketPolicy',
    ImageRatioAssistant: 'specs.events.ui.ImageRatioAssistant',
    AiCreateCategoryAssistant: 'specs.events.ui.AiCreateCategoryAssistant',
    AiCategoriesQaAssistant: 'specs.events.ui.AiCategoriesQaAssistant',
    SkillMembershipsQA: 'specs.events.ui.SkillMembershipsQA',
    AiGuestsAndOrdersQaAssistant: 'specs.events.ui.AiGuestsAndOrdersQaAssistant',
    AiCreateScheduleItemAssistant: 'specs.events.ui.AiCreateScheduleItemAssistant',
    AiCreateRegistrationFormFieldAssistant: 'specs.events.ui.AiCreateRegistrationFormFieldAssistant',
    AiPromotionsAssistant: 'specs.events.ui.PromotionsAssistantQA',
    SkillSeatingQA: 'specs.seatings.ui.SkillSeatingQA',
    FeaturedEventWidget: 'specs.events.ui.FeaturedEventWidget',
    DisableRicosImageGeneration: 'specs.events.ui.DisableRicosImageGeneration',
    NewClassicEvents: 'se_eventsCategoryNewContentInAddPanel', // Add panel
    BulkGuestRemove: 'specs.events.ui.BulkGuestRemove',
    RenameTicketPolicyAI: 'specs.events.ui.RenameTicketPolicyAI',
    AssignTicketsOccupiedSeats: 'specs.events.ui.AssignTicketsOccupiedSeats',
    VistaprintEntryPoint: 'specs.events.ui.VistaprintEntryPoint',
    ButtonLayoutEmptyState: 'specs.events.ui.ButtonLayoutEmptyState',
    EmailsForManuallyAddedRsvps: 'specs.events.ui.EmailsForManuallyAddedRsvps',
    NavigateToEcomCheckout: 'specs.events.ui.NavigateToEcomCheckout',
    PublishSiteBanners: 'specs.events.ui.PublishSiteBanners',
    CalendarRevamp: 'specs.events.ui.CalendarRevamp',
    UseWixForms: 'specs.events.ui.useWixForms',
    MPANavigation: 'specs.events.ui.MPANavigation',
    MobileCalendarRewire: 'specs.events.ui.MobileCalendarRewire',
    UseWixFormsComposer: 'specs.events.ui.useWixFormsComposer',
    FixSeatingModalPosition: 'specs.events.ui.FixSeatingModalPosition',
    AvoidCrossDCCalls: 'specs.events.ui.AvoidCrossDCCalls',
    RemoveKeyPropFromNavigationBar: 'specs.events.ui.RemoveKeyPropFromNavigationBar',
    UpdateFormBuilderControlCreation: 'specs.events.ui.UpdateFormBuilderControlCreation',
    RecentlyUsedLocations: 'specs.events.ui.RecentlyUsedLocations',
    EventTypeChange: 'specs.events.ui.EventTypeChange',
    CheckInTimestamp: 'specs.events.ui.CheckInTimestamp',
    DelayPaymentModalLocalization: 'specs.events.ui.DelayPaymentModalLocalization',
    EditMultipleRecurringEvents: 'specs.events.ui.EditMultipleRecurringEvents',
};
//# sourceMappingURL=experiments.js.map